document.addEventListener('DOMContentLoaded', () => {

  const STORAGE_KEY = 'growingIvyGiftReady';

  const VARIANTS = {
    complimentaryWrapping: 53350695502187,
    boutiqueGiftBox: 53350539100523,
    complimentaryNote: 53350695731563,
    premiumCard: 53350704644459
  };

  const container =
    document.getElementById('gi-gift-ready');

  if (!container) return;

  const checkbox =
    document.getElementById('gi-gift-toggle');

  const content =
    document.getElementById('gi-gift-content');

  const packagingInputs =
    document.querySelectorAll(
      'input[name="gift_packaging"]'
    );

  const cardInputs =
    document.querySelectorAll(
      'input[name="gift_card"]'
    );

  const messageInput =
    document.querySelector('.gi-textarea');

  const textInputs =
    document.querySelectorAll('.gi-input');

  const toInput = textInputs[0];
  const fromInput = textInputs[1];

  function getSelectedValue(inputs) {
    const checked =
      Array.from(inputs).find(
        input => input.checked
      );

    return checked ? checked.value : null;
  }

  async function addVariant(variantId) {

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });
  }

  async function removeVariant(variantId) {

    const cart =
      await fetch('/cart.js')
      .then(r => r.json());

    const lineItem =
      cart.items.find(
        item =>
          item.variant_id ===
          variantId
      );

    if (!lineItem) return;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/json'
      },
      body: JSON.stringify({
        id: lineItem.key,
        quantity: 0
      })
    });
  }

  async function syncPackaging() {

    const selected =
      getSelectedValue(
        packagingInputs
      );

    await removeVariant(
      VARIANTS.complimentaryWrapping
    );

    await removeVariant(
      VARIANTS.boutiqueGiftBox
    );

    if (
      selected ===
      'complimentary'
    ) {
      await addVariant(
        VARIANTS
          .complimentaryWrapping
      );
    }

    if (
      selected ===
      'gift_box'
    ) {
      await addVariant(
        VARIANTS
          .boutiqueGiftBox
      );
    }
  }

  async function syncCard() {

    const selected =
      getSelectedValue(cardInputs);

    await removeVariant(
      VARIANTS.complimentaryNote
    );

    await removeVariant(
      VARIANTS.premiumCard
    );

    if (
      selected ===
      'complimentary'
    ) {
      await addVariant(
        VARIANTS
          .complimentaryNote
      );
    }

    if (
      selected ===
      'premium'
    ) {
      await addVariant(
        VARIANTS
          .premiumCard
      );
    }
  }

  function saveState() {

    const state = {
      enabled:
        checkbox.checked,

      packaging:
        getSelectedValue(
          packagingInputs
        ),

      card:
        getSelectedValue(
          cardInputs
        ),

      message:
        messageInput.value,

      to:
        toInput.value,

      from:
        fromInput.value
    };

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(state)
    );
  }

  async function clearGiftCart() {

    await removeVariant(
      VARIANTS
        .complimentaryWrapping
    );

    await removeVariant(
      VARIANTS
        .boutiqueGiftBox
    );

    await removeVariant(
      VARIANTS
        .complimentaryNote
    );

    await removeVariant(
      VARIANTS
        .premiumCard
    );
  }

  async function updateUI() {

    if (checkbox.checked) {

      content.classList.add(
        'is-active'
      );

      await syncPackaging();
      await syncCard();

    } else {

      content.classList.remove(
        'is-active'
      );

      packagingInputs[0]
        .checked = true;

      cardInputs[0]
        .checked = true;

      messageInput.value =
        '';

      toInput.value = '';
      fromInput.value = '';

      await clearGiftCart();
    }

    saveState();

    
    window.location.reload();
  }

  function restoreState() {

    const saved =
      localStorage.getItem(
        STORAGE_KEY
      );

    if (!saved) return;

    const state =
      JSON.parse(saved);

    checkbox.checked =
      state.enabled || false;

    if (state.packaging) {

      packagingInputs
        .forEach(input => {

        input.checked =
          input.value ===
          state.packaging;

      });
    }

    if (state.card) {

      cardInputs
        .forEach(input => {

        input.checked =
          input.value ===
          state.card;

      });
    }

    if (state.message) {
      messageInput.value =
        state.message;
    }

    if (state.to) {
      toInput.value =
        state.to;
    }

    if (state.from) {
      fromInput.value =
        state.from;
    }

    if (checkbox.checked) {
      content.classList.add(
        'is-active'
      );
    }
  }

  checkbox.addEventListener(
    'change',
    updateUI
  );

  packagingInputs
    .forEach(input => {

    input.addEventListener(
      'change',
      async () => {

        await syncPackaging();

        saveState();

        window.location.reload();
      }
    );

  });

  cardInputs
    .forEach(input => {

    input.addEventListener(
      'change',
      async () => {

        await syncCard();

        saveState();

        window.location.reload();
      }
    );

  });

  messageInput
    .addEventListener(
      'input',
      saveState
    );

  toInput
    .addEventListener(
      'input',
      saveState
    );

  fromInput
    .addEventListener(
      'input',
      saveState
    );

  restoreState();

});